import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'

interface AmazonFeatureCardProps {
  title: string | React.ReactNode
  altTitle?: string
  description: string
  imageUrl: string
  oekoTex?: boolean
}

export const AmazonFeatureCard = ({
  title,
  altTitle,
  description,
  imageUrl,
  oekoTex = false,
}: AmazonFeatureCardProps) => {
  return (
    <div className='group relative flex aspect-[435/558] h-full flex-col justify-end overflow-hidden rounded-lg text-white'>
      <Image
        src={ImageHelper.getImageUrl(imageUrl)}
        alt={altTitle ?? (typeof title === 'string' ? title : '')}
        fill
        className='object-cover transition-transform duration-500 group-hover:scale-105'
      />

      <div className='absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent'></div>

      <div className='relative z-10 bg-gradient-to-t from-neutral-800 to-transparent p-6'>
        {oekoTex && (
          <Image
            src={ImageHelper.getImageUrl('/image/October2025/mceclip16.png')}
            alt='Oeko-Tex Standard 100'
            width={50}
            height={100}
            className='mb-2 h-12 w-auto object-contain md:h-24'
          />
        )}
        <h3 className='text-base font-medium uppercase md:text-lg 2xl:text-2xl'>
          {title}
        </h3>
        <p className='mt-1 text-xs text-white md:text-sm 2xl:text-base'>
          {description}
        </p>
      </div>
    </div>
  )
}
